import { render, staticRenderFns } from "./NoMessages.vue?vue&type=template&id=61647b51&scoped=true&"
import script from "./NoMessages.vue?vue&type=script&lang=ts&"
export * from "./NoMessages.vue?vue&type=script&lang=ts&"
import style0 from "./NoMessages.vue?vue&type=style&index=0&id=61647b51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61647b51",
  null
  
)

export default component.exports